// @flow

import PopupModalButton from './PopupModalButton';
import Notifications from '../constants/Notifications';

export default class CarouselPopupButton extends PopupModalButton {
  /**
   * @inheritDoc
   */
  handleClickEvents(e: Event) {
    super.handleClickEvents(e);
    this.notify(Notifications.TOGGLE_SCROLLBAR_STATE);
    this.notify(Notifications.RESET_ZOOM);
  }
}
